/** @format */

export const DEFAULT_TEST_ID = 'journey-feedback';

/**
 * The datalayer event a verdict is reported as. Named for the section being
 * judged — `KIT_JOURNEY_*` — rather than for this row or the experiment as a
 * whole, the same scheme every event in `beta-model-insights` follows.
 *
 * Declared here rather than added to `client/global/analytics` so that nothing
 * outside `beta-model-insights` has to know this experiment exists.
 */
export const JOURNEY_FEEDBACK_EVENT = 'KIT_JOURNEY_FEEDBACK';

export enum JourneyFeedbackVerdict {
    USEFUL = 'useful',
    NOT_USEFUL = 'not_useful',
}
